import React from 'react';
import { Rocket, Target, Users } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const LookingFor = ({ data }) => {
  const qualities = [
    {
      icon: <Rocket className="h-8 w-8" />,
      title: "Early-Stage Focus",
      description: "Ready to join a team where every decision shapes the product's future"
    },
    {
      icon: <Target className="h-8 w-8" />,
      title: "Product Ownership",
      description: "Looking to own core UI architecture and drive meaningful product outcomes"
    },
    {
      icon: <Users className="h-8 w-8" />,
      title: "Collaborative Growth",
      description: "Excited to work closely with founders and grow with the company's vision"
    }
  ];

  return (
    <section id="looking-for" className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold text-white mb-4 tracking-tight">
            {data.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-500 to-teal-400 mx-auto mb-6" />
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="bg-gray-900/40 border border-gray-800/50 mb-12 hover:border-gray-700/80 transition-all duration-300">
            <CardContent className="p-8">
              <p className="text-lg text-gray-300 leading-relaxed text-center">
                {data.description}
              </p>
            </CardContent>
          </Card>

          <div className="grid md:grid-cols-3 gap-6">
            {qualities.map((quality, index) => (
              <Card key={index} className="bg-gray-900/40 border border-gray-800/50 hover:border-gray-700/80 transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/5">
                <CardContent className="p-6 text-center">
                  <div className="text-emerald-400 mb-4 flex justify-center">
                    {quality.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-3 tracking-tight">
                    {quality.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {quality.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LookingFor;